module.exports = __webpack_public_path__ + "static/media/resumeSS2.2adf1660.png";